import mountVues from "@galaxy/modules/Core/resources/js/mountVues";

common.View.create('crud::form.Ajax', {

    ajaxCalls: [],

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initAjax();
    },

    /**
     * Initializes the GUI.
     */
    initAjax()
    {
        // Get input
        let $input = $('html, body').find('[name="' + this.element.data('input') + '"]');

        // Find input that will activate the postback
        $input
            // On change event of that input
            .on(this.element.data('trigger'), (event) =>
            {
                // Re-render view based on input change
                this.viewRerender(event.currentTarget);
            })
            .end();

        this.viewRerender($input);
    },

    viewRerender(input)
    {
        for(const ajaxCall of this.ajaxCalls) {
            ajaxCall.abort();
            this.ajaxCalls.splice(this.ajaxCalls[ajaxCall], 1);
        }

        // Re-render view
        let ajaxCall = $.post('/galaxy/crud/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'form/ajax', {
            'input': this.getCurrentInputValue(input),
            'view': this.element.data('view'),
            'action': this.element.data('action'),
        }).done((data) => {
            this.element.find('.ajaxContent').html(data);

            // Re init vue
            mountVues(this.element);

            // Run trigger
            this.element.trigger('crud::form-ajax:change');

            // Re init view
            common.View.reinit();
        });

        this.ajaxCalls.push(ajaxCall);
    },

    getCurrentInputValue(input)
    {
        // Is checkable?
        if ($.inArray($(input).attr('type'), ['checkbox', 'radio']) !== -1) {
            return $('input[name="' + input.name + '"]:checked').val();
        }

        // Is switch input?
        if ($(input).parents('[class*="crud::form-inputs"]').is('[class*="Switch"]')) {
            return $(input).attr('checked');
        }

        return $(input).val();
    },

});
